import React from 'react';
import {QUESTION_TYPE_TYPE} from 'records/CoachingReviewTypeQuestion';
import './ReviewTypeQuestionResults.styl';
import {answersFor} from 'records/Scorecard';
import CircularProgress from 'components/pure/utils/CircularProgress';
import {RichText} from 'components/pure/utils/form/user-taggable-input/RichTextEditor';
import {htmlDecode} from 'components/triggers/BulletedMatchedRuleDescription';
import {isNonEmptyAnswer} from 'components/coaching/IsNonEmptyAnswer';
import {getMuiV4Theme} from 'utils/css/themeUtils';

export default class ReviewTypeQuestionResults extends React.PureComponent {
  render() {
    const {reviewType, answers} = this.props;

    if (!reviewType) return null;
    if (reviewType.questions.isEmpty()) return null;

    return (
      <section className="review-type-question-results">
        {reviewType.questions
          .sortBy(question => question.index)
          .map(question => {
            const answer =
              answers && answers.find(answer => answer.reviewQuestionId === question.id);
            return (
              isNonEmptyAnswer(answer) && (
                <div className="question-container" key={question.id}>
                  <div className="empty-space" />
                  <div className="question">
                    <RichText className="prompt" dangerousText={question.text} />
                    <Answer
                      question={question}
                      answer={answer}
                      answers={answersFor(question.type)}
                    />
                  </div>
                </div>
              )
            );
          })}
      </section>
    );
  }
}

function Answer({question, answer, answers}) {
  if (!answer) return <div className="answer" />;
  const textBased = [QUESTION_TYPE_TYPE.TextArea, QUESTION_TYPE_TYPE.TextField].includes(
    question.type
  );
  const twoOptions = [QUESTION_TYPE_TYPE.PassFail, QUESTION_TYPE_TYPE.YesNo].includes(
    question.type
  );
  const threeOptions = QUESTION_TYPE_TYPE.OneToThree === question.type;

  if (textBased) return <div className="answer">{htmlDecode(answer.comment)}</div>;

  if (answer.score === null) return <div className="answer">N/A</div>;

  if (twoOptions) {
    const {label} = answers.find(a => a.value === answer.score) || {};
    return <div className="answer yesno">{label}</div>;
  }

  let score;
  if (threeOptions) {
    score = {
      0: 0.0,
      1: 33.0,
      3: 67.0,
      5: 100.0,
    }[answer.score];
  } else {
    score = answer.score * 20;
  }

  if (score == null || Number.isNaN(score)) return null;

  return (
    <div className="answer">
      <div className="donut-score">
        <CircularProgress percentage={score} color={getMuiV4Theme().palette.primary.main} />
        <span className="score-text">{score}%</span>
      </div>
    </div>
  );
}
